import { object, string, boolean, date } from 'yup';
import { validateEmail } from './global';

export const rabehLoyaltyValidation = (t) =>
  object().shape({
    name: string().required(t('name_required')),
    email: string()
      .matches(validateEmail, t('invalidEmail'))
      .required(t('emailRequired')),
    gender: string().required(t('gender_required')),
    dob: date()
      .typeError(t('birth_date_invalid'))
      .max(new Date(), t('birth_date_future'))
      .required(t('birth_date_required')),
    phone_number: string()
      .label('mobileNumber')
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t('telephoneError1'))
      .matches(/^5[0-9]{8}$/, t('telephoneError2'))
      .min(9)
      .required(t('TelephoneRequired')),
    marital_status: string().required(t('marital_status_required')),
    profession: string().required(t('work_sector_required')),
    acceptedTerms: boolean()
      .oneOf([true], t('terms_required'))
      .required(t('terms_required')),
    country: string().required(t('country_required')),
  });
